export default __webpack_public_path__ + "static/media/OlivaChurchilOpen.5eebc044.jpg";